import { gql } from 'urql';

const SubmitFlexPayOverTimePlan = gql`
  mutation SubmitFlexPayOverTimePlan(
    $idempotencyId: IdempotencyToken!
    $input: SubmitFlexPayOverTimePlanInput!
  ) {
    submitFlexPayOverTimePlan(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on SubmitFlexPayOverTimePlanSuccess {
        planId
        summary
      }
      ... on SubmitFlexPayOverTimePlanError {
        code
        title
        message
      }
    }
  }
`;

export default SubmitFlexPayOverTimePlan;
